import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useParams } from 'react-router-dom';

import styles from "./RoomsceneSwitcher.module.css";
import refreshIcon from './assets/refresh.svg';
import checkIcon from './assets/check.svg';

export default function RoomsceneSwitcher() {

    const urlParams = useParams();

    const activePlan = useSelector((state) => state.visualizer.activeFloorPlanData);
    const activeArea = urlParams.area;

    if(!activePlan) return false;

    const scenesData = [
        { name: 'Exterior', area: 'exterior', specifier: activePlan["exterior"], sel: activePlan["exteriorSel"] },
        { name: 'Kitchen', area: 'kitchen', specifier: activePlan["kitchen"] , sel: activePlan["kitchenSel"] },
        { name: 'Bathroom', area: 'bathroom', specifier: activePlan["bathroom"] , sel: activePlan["bathroomSel"] },
    ];

  

    const scenesList = scenesData.map((scene, index) => (
        <li key={index}>
            <img src={`https://core2render.chameleonpower.com/cham/GetImage.ashx?spec=${scene.specifier}&type=base&size=300`} alt="scene thumbnail" />
            {(scene.area === activeArea) && <span><img src={checkIcon} alt="Refresh Icon" /> Selected</span>}
            {(scene.area !== activeArea) &&
                <Link to={`/visualizer/floorplan/${activePlan["id"]}/area/${scene.area}/spec/${encodeURIComponent(scene.specifier)}/sel/${scene.sel}`}><img src={refreshIcon} alt="Refresh Icon" /> Switch To</Link>
            }
        </li>
    ));

    return (
        <>
            {activePlan &&
                <div className={styles.content}>
                    <div className={styles.scenes}> {
                        <ul>
                            {scenesList}
                        </ul>
                    }
                    </div>

                </div>
            }
        </>
    );
}